import { createAsyncThunk } from "@reduxjs/toolkit";
import apiEndpoints from "../../const/apiEndpoints";
import api from "../../services";

export const getCounts = createAsyncThunk(
    'count/getCounts',
    async (userId: string): Promise<any> => {
        const response = await api.get(`${apiEndpoints.getDashboardCount}${userId}`)
        return response.data
    }
) 